enum LabelResourceTypes {
  CNX = 'cnx',
  DON = 'don',
}

export default LabelResourceTypes;
